import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterOutlet } from '@angular/router';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

    title = 'web-staff-admin';

    constructor(
        private activatedRoute: ActivatedRoute,
        private router: Router) {
    }

    ngOnInit() {

    }
}
